'use client';

import classnames from 'classnames';
import { StreamSessionWrapperProps } from './streamSessionWrapper.types';

const StreamSessionWrapper = ({
  classNames = [],
  children,
  nativeProps = {},
}: StreamSessionWrapperProps) => {
  const classes = classnames(classNames);

  return (
    <div {...nativeProps} className={classes}>
      {children}
    </div>
  );
};

export default StreamSessionWrapper;
